module.exports = __webpack_public_path__ + "static/img/sustainable-low.2000f19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/sustainable-low.jpg
// module id = xPAo
// module chunks = 0